import React, { useEffect, useRef, useState,useMemo } from "react";
import CheckBoxRoundedIcon from "@material-ui/icons/CheckBoxRounded";
import OfflineBoltRoundedIcon from "@material-ui/icons/OfflineBoltRounded";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import CircularProgress from "@material-ui/core/CircularProgress";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@material-ui/core";
import IssueTitleCell from "./Issuetitle.js";
import Box from "@mui/material/Box";
import { Bookmark } from "@mui/icons-material";
import "../../App.css";
import { fetchUserById } from "./ManagerNotesslice.js";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PropTypes from "prop-types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ManagerNotes from "./ManagerNotes.jsx";
import { Avatar } from "@mui/material";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Table
} from "@material-ui/core";
import { KeyboardArrowRight, Add, CreateNewFolder } from "@mui/icons-material";
import { MTableBodyRow } from "material-table";
import agile from "../../assets/images/agile.png";
import { makeStyles } from "@material-ui/core/styles";
import Select, { components } from "react-select";
import { TextField } from "@material-ui/core";
import { Slide, toast } from "react-toastify";
import { Row, Col, Label } from "reactstrap";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import "./Showrelease.css";
import { Input } from "reactstrap";
import { Button } from "@material-ui/core";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import slacknotify from "../../slacknotify.js";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import Unassigned from "../../assets/images/avatar.png";
import PatchedPagination from "../../PatchedPagination";
import { ProgressBar, Toast } from "react-bootstrap";
// import axios from "axios";
import axios from "../../axios";
import Cookies from "universal-cookie";
import { HANDLE_ON_CHANGE } from "../../redux/CommonInitialsate";
import Mailandnotification from "../../Mailandnotification";
import { Popover, Space } from "antd";

const useStyles = makeStyles({
  root: {
    color: "rgb(254, 192, 84)", // Default color
  },
  greenSlider: {
    color: "green",
  },
  yellowSlider: {
    color: "yellow",
  },
  orangeSlider: {
    color: "orange",
  },
  redSlider: {
    color: "red",
  },
});

const useStyles1 = makeStyles({
  disabledSlider: {
    "& .MuiSlider-thumb": {
      backgroundColor: "#2196f3", // Thumb color
    },
    "& .MuiSlider-track": {
      backgroundColor: "#2196f3", // Active track color
    },
    "& .MuiSlider-rail": {
      backgroundColor: "#d3d3d3", // Inactive track color
    },
  },
});

export default function HistoryTable({
  fetchData,
  data,
  labelvi,
  remove,
  setremove,
  Reasonoption,
  handleissueid,
  mydatashow,
  removed,
  refresh,
  optionversionchange,
  vesionselectedvalue,
}) {
  const {
    allImage,
    projectRole,
    employeeList,
    mydatashow1,
    projectName,
    projectCode,
    EmpDropDownData,
    channelname,
    slacktoken,
    releasedata,
    projectDetails,
    resData,
    projectId2,
    FilteredData
  } = useSelector((state) => state.user);
  const { data: selectorData } = useSelector((state) => state.note);



  let productRole = JSON.parse(localStorage.getItem("ProductRole"));
  const getProdRole = productRole?.filter((e) => e.ProdId == "11004")[0]
    ?.RoleCode;
  const userid =
    localStorage.getItem("userid") == undefined
      ? ""
      : JSON.parse(localStorage.getItem("userid"));
  const username =
    localStorage.getItem("username") == undefined
      ? ""
      : JSON.parse(localStorage.getItem("username"));

  const classes = useStyles();
  const cookies = new Cookies();
  const processAndSortData = (data) => {
    let stories = [];
    let otherIssues = [];

    data?.forEach((item) => {
      if (item.IssueType === "Story") {
        stories.push(item);
      } else {
        otherIssues.push(item);
      }
    });

    const storyMap = new Map();
    stories.forEach((story) => {
      storyMap.set(story.IssueIdS, story);
    });

    let combinedData = [];
    storyMap.forEach((story) => {
      combinedData.push(story);
      otherIssues.forEach((issue) => {
        if (
          issue.IssueType === "SubTask" &&
          issue.Parentissue &&
          issue.Parentissue[0]?.IssueId === story.IssueIdS
        ) {
          combinedData.push(issue);
        }
      });
    });

    otherIssues.forEach((issue) => {
      if (
        issue.IssueType !== "SubTask" ||
        !issue.Parentissue ||
        !storyMap.has(issue.Parentissue[0]?.IssueId)
      ) {
        combinedData.push(issue);
      }
    });

    return combinedData;
  };

  const combinedSortedData = processAndSortData(data);

  
  // Calculate the color based on the value of e.percentageprogressed
  const getColor = (percentage) => {
    if (percentage >= 75) return classes.greenSlider;
    else if (percentage >= 50) return classes.yellowSlider;
    else if (percentage == 0) return classes.redSlider;
    else return classes.root; // Default color
  };

  const rowsPerPage = 20;
  const [page, setPage] = React.useState(1);
  const [releasePopover2, setReleasePopover2] = useState(null);
  const popoverRef = React.useRef(null);
  const [insidePopoverContent, setInsidePopoverContent] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [messagetype, setMessageType] = useState("success");
  let slack = localStorage.getItem("Slack");
  const clientId = localStorage.getItem("clientid");
  let emplogin = JSON.parse(localStorage.getItem("Empdetails"));
  let login = emplogin != null ? emplogin : null;
  const [popoverVisible, setPopoverVisible] = useState(null);
  const [priorityVisible, setpriorityVisible] = useState(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [cdata, setcdata] = useState([]);
  const [clon, setclon] = useState(false);
  const [stage, setStage] = useState("Refined");
  const [issueTitleedit, setIssueTitleedit] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
  const [sprintc, setSprintc] = useState(null);
  const [assignedEmployeec, setAssignedEmployeec] = useState(null);
  const [assignedEmployeeNc, setAssignedEmployeeNc] = useState("null null");
  const [isSubmittingc, setIsSubmittingc] = useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleStageChange = (value) => {
    setStage(value);
  };
  // Calculate the index range of the current page
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  // Get the data for the current page
  const paginatedData = data?.slice(startIndex, endIndex);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        releasePopover2 !== null &&
        !popoverRef.current.contains(event.target) &&
        !insidePopoverContent
      ) {
        setReleasePopover2(null);
      }
    };

    if (releasePopover2 !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [releasePopover2]);

  // function handlereason(e, i, x) {
  //     console.log(e)
  //     console.log(x)
  //     console.log(remove)
  //     console.log(i)
  //     let a = [...remove];
  //     a?.splice(i, 1, {
  //         ReleaseDate: moment().format("YYYY-MM-DD"),
  //         IsReleaseFrozen: "Y",
  //         RemovedTickets: {
  //             IssueId: x.IssueIdS,
  //             IssueTitle: x.IssueTitle,
  //             AssignedToDetails: x.AssignedToDetails,
  //             Assignedto: x.Assignedid,
  //             Reason: e.value,
  //             notes: null,
  //         },
  //     });
  //     console.log(a, "Aaaa");
  //     setremove(a);
  // }

  // const handlenotes = (e, i, x) => {
  //     console.log(e, i, x)
  //     console.log(remove[i]?.RemovedTickets?.Reason)
  //     let a = [...remove];

  //     a?.splice(i, 1, {
  //         ReleaseDate: moment().format("YYYY-MM-DD"),
  //         IsReleaseFrozen: "Y",
  //         RemovedTickets: {
  //             IssueId: x.IssueIdS,
  //             IssueTitle: x.IssueTitle,
  //             AssignedToDetails: x.AssignedToDetails,
  //             Assignedto: x.Assignedid,
  //             Reason: remove[i]?.RemovedTickets?.Reason,
  //             notes: e.target.value ? e.target.value : null,
  //         },
  //     });
  //     console.log(a, "remove check")
  //     setremove(a);

  //     // let notevalue = [...notes];

  //     // notevalue.splice(item?.item, 1, {
  //     //   note: e.label,
  //     // });

  //     // setnotes(notevalue);
  // };
  const handleInputChange = (event) => {
    setIssueTitleedit(event.target.value);
  };
  const CustomSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={agile}
        alt="Image"
        width="30"
        height="30"
        style={{ marginRight: "2px" }}
      />
      <span>{data.label}</span>
    </div>
  );

  const CustomOption = (props) => (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={agile}
          alt="Image"
          width="30"
          height="30"
          style={{ marginRight: "2px" }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );
  const EmployeeDropdownc = resData
    .filter((x) => x.projectcode == projectId2)
    ?.map((e) => ({
      label: e.firstname + " " + e.lastname,
      value: e.teammemberid,
    }))
    ?.filter(
      (obj, index, self) =>
        index ===
        self.findIndex((o) => o.label === obj.label && o.value === obj.value)
    );
  function handleAssignedTo(item) {
    setAssignedEmployeec(item.value);
    setAssignedEmployeeNc(item.label);
  }
  function handlereason(e, i, x) {
    setremove((prevRemove) => {
      const updatedRemove = [...prevRemove];
      updatedRemove[i] = {
        ReleaseDate: moment().format("YYYY-MM-DD"),
        IsReleaseFrozen: "Y",
        RemovedTickets: {
          IssueId: x.IssueIdS,
          IssueTitle: x.IssueTitle,
          AssignedToDetails: x.AssignedToDetails,
          Assignedto: x.Assignedid,
          Reason: e.value,
          notes: updatedRemove[i]?.RemovedTickets?.notes,
        },
      };
      return updatedRemove;
    });
  }

  const handlenotes = (e, i, x) => {
    setremove((prevRemove) => {
      const updatedRemove = [...prevRemove];
      updatedRemove[i] = {
        ReleaseDate: moment().format("YYYY-MM-DD"),
        IsReleaseFrozen: "Y",
        RemovedTickets: {
          IssueId: x.IssueIdS,
          IssueTitle: x.IssueTitle,
          AssignedToDetails: x.AssignedToDetails,
          Assignedto: x.Assignedid,
          Reason: updatedRemove[i]?.RemovedTickets?.Reason,
          notes: e.target.value ? e.target.value : null,
        },
      };
      return updatedRemove;
    });
  };

  const userdropdownoptions = employeeList.map((x) => {
    return {
      value: x.teammemberid,
      label: x.firstname + " " + x.lastname,
      firstname: x.firstname,
      lastname: x.lastname,
      icon: (
        <Avatar
          // className="progressName"
          src={
            allImage?.length > 0
              ? allImage?.filter((e) => e.teammemberid == x.teammemberid)?.[0]
                  ?.image
              : Unassigned
          }
        />
      ),
    };
  });
  let empid = JSON.parse(localStorage.getItem("Empdetails"));
  const dispatch = useDispatch();
  const handleSelectChange = (selectedOption, issueId, assignedto, e) => {
    if (assignedto != selectedOption?.value) {
      axios
        .patch("agilesaas_issue_details?IssueId=eq." + e.IssueIdS, {
          AssignedTo: selectedOption.value,
          AssignedToDetails: {
            FN: selectedOption?.firstname,
            LN: selectedOption?.lastname,
          },
        })
        .then((res) => {
          //   refresh();
          const updatedData = mydatashow.map((item) =>
            item.IssueIdS === e.IssueIdS
              ? {
                  ...item,
                  Assignedid: selectedOption?.value,
                  AssignedToDetails: selectedOption?.label,
                  FN: selectedOption?.firstname,
                  LN: selectedOption?.lastname,
                }
              : item
          );
          const updatedData1 = mydatashow1.map((item) =>
            item.IssueIdS === e.IssueIdS
              ? {
                  ...item,
                  Assignedid: selectedOption?.value,
                  AssignedToDetails: selectedOption?.label,
                  FN: selectedOption?.firstname,
                  LN: selectedOption?.lastname,
                }
              : item
          );
          dispatch(
            HANDLE_ON_CHANGE({ name: "mydatashow", value: updatedData })
          );
          dispatch(
            HANDLE_ON_CHANGE({ name: "mydatashow1", value: updatedData1 })
          );
          Mailandnotification(
            e,
            employeeList?.filter(
              (x) => x.teammemberid == selectedOption?.value
            )?.[0]?.email,
            [empid?.[0]?.OfficialEmail],
            true, // web notify
            true, // for mail
            projectName,
            "New Card Assigned",
            "A new card has been assigned to you"
          );
          let posthistory = {
            IssueId: e.IssueIdS,
            ChangedBy: empid?.[0]?.ClientUserId,
            ChangedByDetails: {
              FN: empid?.[0]?.UserFirstname,
              LN: empid?.[0]?.UserLastname,
            },
            ChangedDate: moment(),
            UpdatedField: "Assignee",
            UpdatedFrom: e.AssignedToDetails,
            UpdatedTo: selectedOption.label,
            UpdateSequence: 1,
            IsActive: "Y",
            ClientId: empid?.[0]?.ClientId,
            ProjectId: projectCode,
          };
          axios
            .post(`agilesaas_issue_history`, posthistory)
            .then((response) => {
              console.log(response);
            });
        })
        .catch((error) => console.log(error));
    }
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: 150,
      padding: 0,
      margin: 0,
      background: "#fff",
      border: state.isFocused
        ? "0px solid rgb(82, 80, 223)"
        : "0px solid rgba(0, 0, 0, 0.10)",
      borderRadius: 8,
      // width: '110%',
      // marginLeft: elementWidth > 1300 ? -35 : -20,

      // height: "50px",
      // background: "#f3f3ff",
      // match with the menu
      // borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      // borderColor: state.isFocused ? "yellow" : "green",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        // borderColor: state.isFocused ? "red" : "blue"
      },
    }),
    menu: (base) => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      // marginTop: 0,
      // marginLeft: elementWidth > 1300 ? -35 : -20,
      width: `${Math.max(
        ...userdropdownoptions.map((option) => option.label.length * 10)
      )}px`, // Adjust the multiplier based on your content
      minWidth: "100%",
      zIndex: 9999, // Ensure the dropdown appears above other elements
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // This ensures the portal has a high zIndex
  };
  const customStylesclone = {
    control: (base, state) => ({
      ...base,
      background: "#FFF",
      border: state.isFocused
        ? "2px solid rgb(82, 80, 229)"
        : "1px solid rgba(0, 0, 0, 0.10)",
      borderRadius: 8,
      height: "2.875rem",
      // background: "#f3f3ff",
      // match with the menu
      // borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      // borderColor: state.isFocused ? "yellow" : "green",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        // borderColor: state.isFocused ? "red" : "blue"
      },
    }),
    menu: (base) => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };
  const releasesOption =
    releasedata?.filter((item) => item.IsReleaseFrozen == "N")?.length == 0
      ? []
      : releasedata
          ?.filter(
            (item) =>
              (item.IsReleaseFrozen == "N" &&
                moment(item.SprintStartDate) < moment() &&
                moment(item.SprintEndDate) > moment()) ||
              moment() < moment(item.SprintStartDate)
          )
          ?.map((e) => {
            return {
              ...e,
              label: e.ReleaseName,
              value: e.ReleaseName,
            };
          });

  const filteredRele = releasesOption.filter(
    (release) => moment(release.SprintStartDate).diff(moment(), "days") < 0
  );
  // console.log(remove, "rrrrrrrrrrrrrrrrrrrrrrrrrrr");
  const displayReason =
    mydatashow?.[0]?.Status == "Y" &&
    removed.length != 0 &&
    labelvi?.includes("To Be Released");
  const displayDropdown =
    labelvi?.includes("To Be Released") &&
    paginatedData.filter(
      (x) =>
        x.Stage == "Refined" ||
        x.Stage == "Backlog" ||
        x.Stage == "In Development"
    ).length != 0;
  // Issue type change //
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       popoverRef.current &&
  //       releasePopover2 !== null &&
  //       !popoverRef.current.contains(event.target) &&
  //       !insidePopoverContent
  //     ) {
  //       // Resetting states when clicking outside

  //       setReleasePopover2(null);
  //     }
  //   };

  //   if (releasePopover2 !== null) {
  //     // Add event listener when any popover is active
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     // Remove event listener when no popover is active
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   // Clean up event listener on unmount or dependency change
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [insidePopoverContent, releasePopover2]);
  function closepppp() {
    setclon(false);
    setSprintc(null);
    setAssignedEmployeeNc(null);
    setAssignedEmployeec(null);
  }
  function handleclonesubmit() {
    setIsSubmittingc(true);
    const firstname =
      assignedEmployeeNc == " " || undefined
        ? " "
        : assignedEmployeeNc?.split(" ").length == 3
        ? assignedEmployeeNc?.split(" ")[0] +
          " " +
          assignedEmployeeNc?.split(" ")[1]
        : assignedEmployeeNc?.split(" ")[0];

    const prjshcode = projectDetails?.filter(
      (e) => e.projectcode == projectCode
    );
    const prjShortCodePart =
      prjshcode[0]?.projectshortcode?.match(/[a-zA-Z]+/)[0];

    let emplastname =
      cdata.IssueType != "Epic" ? assignedEmployeeNc.split(" ").pop() : null;
    let postData = {
      ProjectId: projectId2,
      ProjectShortCode: prjShortCodePart,
      IssueType: "Task",
      IssueTitle: issueTitleedit || cdata.IssueTitle,
      Description: cdata.Description || null,
      Priority: cdata.Priority,
      PlannedRelease: sprintc || filteredRele?.[0]?.ReleaseName,
      EstimateUnit: cdata.IssueType != "Epic" ? "MD" : null,
      EstimateUnitDesc: cdata.IssueType != "Epic" ? "Man Days" : null,

      CurrentStage: [
        {
          StageCode:
            stage == "Backlog" ? "BLG" : stage == "Refined" ? "RFD" : "BLG",
          StageName:
            stage == "Backlog"
              ? "Backlog"
              : stage == "Refined"
              ? "Refined"
              : "Refined",
          DateMoved: moment().format("YYYY-MM-DD"),
        },
      ],
      LinkToEpic:
      cdata.IssueType != "Epic" && cdata.linktoepic ? cdata.linktoepic : null,
      LinkToIssues:
        cdata.IssueType != "Epic" && cdata.Linkedtoissues
          ? cdata.Linkedtoissues
          : null,
      CreatedBy: userid,
      CreatedByDetails: username,
      // arr.RoleName == "Undefined" ? "Kanban Admin" : arr.RoleName,
      CreatedDate: moment().format("YYYY-MM-DD"),
      AssignedTo: cdata.IssueType != "Epic" ? assignedEmployeec : null,
      AssignedToDetails: { FN: firstname, LN: emplastname },
      AssignedDate: moment().format("YYYY-MM-DD"),
      Attachment: cdata.IssueType != "Epic" ? cdata.Attachment : null,
      IsActive: "Y",
      ExceptiontoSkipSPEstimation: "N",
      ProjectDetails: [{ ProjName: projectName }],
      AssignedToUAT: null,
      AssignedToUATDetails: {
        FN: null,
        LN: null,
      },
      ClientId: clientId,
      ModuleLinked: cdata.ModuleLinked || null,
      AttachmentReference: null,
    };
    console.log(postData, "postdata");

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + cookies.get("token"),
      Prefer: "return=representation",
    };

    axios
      .post("agilesaas_issue_details", postData, { headers })
      .then((ress) => {
        console.log("postissuecallinf");

        const newData = [
          {
            IssueId: ress.data?.[0]?.IssueId,
            IssueTitle: ress.data?.[0]?.IssueTitle,
          },
        ];

        // Fetching existing release issues
        return axios
          .get(`agilesaas_releases?ReleaseName=eq.${sprintc}`)
          .then((response) => {
            const existingReleaseIssues = response.data[0]?.ReleaseIssues || [];
            const updatedReleaseIssues = [...existingReleaseIssues, ...newData];

            // Patching updated issues back to release
            return axios.patch(`agilesaas_releases?ReleaseName=eq.${sprintc}`, {
              ReleaseIssues: updatedReleaseIssues,
            });
          })
          .then(() => {
            const historyDataArray = {
              IssueId: ress?.data?.[0]?.IssueId,
              ChangedBy: empid?.[0]?.ClientUserId,
              ChangedByDetails: {
                FN: empid?.[0]?.UserFirstname,
                LN: empid?.[0]?.UserLastname,
              },
              ChangedDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
              UpdatedField: "Issue created",
              UpdatedFrom: "",
              UpdatedTo:
                cdata.IssueType != "Epic" && assignedEmployeec
                  ? "Issue created by " +
                    empid?.[0]?.UserFirstname +
                    " " +
                    empid?.[0]?.UserLastname +
                    " and allocated to " +
                    firstname +
                    " " +
                    emplastname
                  : "Issue created by " +
                    empid?.[0]?.UserFirstname +
                    " " +
                    empid?.[0]?.UserLastname,
              UpdateSequence: null,
              IsActive: "Y",
              Status: null,
              ClientId: clientId,
              ProjectId: projectId2,
            };

            // Posting history data
            return axios.post("agilesaas_issue_history", historyDataArray);
          })
          .then(() => {
            // Success notifications
            toast.success(
              `Success! Issue ${cdata.IssueTitle} has been cloned and added to the ${stage}`,
              {
                transition: Slide,
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
                draggable: true,
              }
            );

            Mailandnotification(
              cdata,
              EmpDropDownData?.filter(
                (x) => x.teammemberid == assignedEmployeec
              )?.[0]?.email,
              [empid?.[0]?.OfficialEmail],
              true,
              true,
              projectName,
              `Issue created,
          ${issueTitleedit} has been created by ${
                empid?.[0]?.UserFirstname + " " + empid?.[0]?.UserLastname
              } in project ${projectName}`
            );

            if (slack && slack === "Y") {
              slacknotify(
                channelname,
                `${issueTitleedit} is created and assigned to ${
                  EmpDropDownData?.filter(
                    (x) => x.teammemberid == assignedEmployeeNc
                  )?.[0]?.firstname +
                  " " +
                  EmpDropDownData?.filter(
                    (x) => x.teammemberid == assignedEmployeec
                  )?.[0]?.lastname
                } by ${
                  empid?.[0]?.UserFirstname + " " + empid?.[0]?.UserLastname
                } in project ${projectName}`,
                slacktoken
              );
            }

            setIsSubmittingc(false);
            dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
            closepppp();
          })
          .catch((patchError) => {
            console.error(
              "Error in history post or slack/mail notification:",
              patchError
            );
            setIsSubmittingc(false);
          });
      })
      .catch((e) => {
        console.error("Error in creating issue or fetching release data:", e);
        setIsSubmittingc(false); // Reset the submission state
      });
  }
  const updateIssueType = async (e, x) => {
    if (e.IssueType !== x) {
      let data = {
        IssueType: x,
      };
      try {
        // Update the issue type
        await axios.patch(
          `agilesaas_issue_details?IssueId=eq.${e.IssueIdS}`,
          data
        );

        // Dispatch refresh action
        fetchData();
        // optionversionchange({ label: labelvi, value: vesionselectedvalue });
        dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
        // setOpen(true);
        toast.success("Issue type updated successfully.");
        setReleasePopover2(null); // Close the popover
        // setMessage(`Issue type updated successfully.`);
        // setMessageType("success");
        // Send email notification if assigned email is present

        //extra for email, slack and assignee //

        // const assignedMember = EmpDropDownData?.find(
        //   (emp) => emp.teammemberid === e?.AssignedTo
        // );
        // if (assignedMember?.email) {
        //   Mailandnotification(
        //     e,
        //     assignedMember.email,
        //     [empid?.[0]?.OfficialEmail],
        //     true,
        //     true,
        //     projectName,
        //     "Issue Type Update",
        //     `${e.IssueTitle} is changed to ${x}`
        //   );
        // }

        // // Send Slack notification if Slack is enabled
        // if (slack === "Y") {
        //   await slacknotify(
        //     channelname,
        //     `${e.IssueTitle} issue type is changed to ${x}`,
        //     slacktoken
        //   );
        // }

        // // Log issue history
        // await axios.post("agilesaas_issue_history", {
        //   IssueId: e.IssueIdS,
        //   ChangedBy: clientId,
        //   ChangedByDetails: {
        //     FN: login?.[0]?.UserFirstname,
        //     LN: login?.[0]?.UserLastname,
        //   },
        //   ChangedDate: moment()
        //     .utcOffset("+05:30")
        //     .format("YYYY-MM-DDTHH:mm:ss"),
        //   UpdatedField: "Issue Type",
        //   UpdatedFrom: e.IssueType,
        //   UpdatedTo: x,
        //   UpdateSequence: 1,
        //   IsActive: "Y",
        //   Status: null,
        //   ClientId: clientId,
        //   ProjectId: projectCode,
        // });
        // Close the popover after updating
        setPopoverVisible(false);
      } catch (error) {
        console.error("Error updating issue type:", error);
      }
    }
  };
  // const handleSecondFriend = (rowDataProjectId) => {
  //   // setProjectdetails(
  //   //   projectdetails.map((friend) =>
  //   //     // Here you accept a id argument to the function and replace it with hard coded 🤪 2, to make it dynamic.
  //   //     friend.ProjectId === rowDataProjectId
  //   //       ? { ...friend, selectOption: !friend.selectOption }
  //   //       : { ...friend }
  //   //   )
  //   // );
  //   console.log(rowDataProjectId,"rowdd",selectedId.IssueIdS);
  //   setSelectedId(selectedRow.IssueIdS == rowDataProjectId ? "" : rowDataProjectId);

  // };
  const IssutypeOptions = [
    {
      label: "Story",
      icon: (
        <Bookmark
          className="story fonticons"
          style={{
            fontSize: "13px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "Task",
      icon: (
        <CheckBoxRoundedIcon
          className="task fonticons"
          style={{
            fontSize: "13px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "Bug",
      icon: (
        <StopCircleIcon
          className="bug fonticons"
          style={{
            fontSize: "13px",
            marginRight: "5px",
          }}
        />
      ),
    },
  ];
  // PriorityChange
  const updatePriority = async (e, x) => {
    if (e.Priority !== x) {
      let data = {
        Priority: x,
      };
      try {
        // Update the issue type
        await axios.patch(
          `agilesaas_issue_details?IssueId=eq.${e.IssueIdS}`,
          data
        );

        // Dispatch refresh action
        fetchData();
        dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
        // setOpen(true);
        toast.success("Priority updated successfully.");
        setReleasePopover2(null); // Close the popover
        // setMessage(`Priority updated successfully.`);
        // setMessageType("success");

        // Send email notification if assigned email is present

        //extra for email, slack and assignee //

        // const assignedMember = EmpDropDownData?.find(
        //   (emp) => emp.teammemberid === e?.AssignedTo
        // );
        // if (assignedMember?.email) {
        //   Mailandnotification(
        //     e,
        //     assignedMember.email,
        //     [empid?.[0]?.OfficialEmail],
        //     true,
        //     true,
        //     projectName,
        //     "Priority Type Update",
        //     `${e.Priority} is changed to ${x}`
        //   );
        // }

        // // Send Slack notification if Slack is enabled
        // if (slack === "Y") {
        //   await slacknotify(
        //     channelname,
        //     `${e.Priority} Priority is changed to ${x}`,
        //     slacktoken
        //   );
        // }

        // // Log issue history
        // await axios.post("agilesaas_issue_history", {
        //   IssueId: e.IssueIdS,
        //   ChangedBy: clientId,
        //   ChangedByDetails: {
        //     FN: login?.[0]?.UserFirstname,
        //     LN: login?.[0]?.UserLastname,
        //   },
        //   ChangedDate: moment()
        //     .utcOffset("+05:30")
        //     .format("YYYY-MM-DDTHH:mm:ss"),
        //   UpdatedField: "Issue Type",
        //   UpdatedFrom: e.IssueType,
        //   UpdatedTo: x,
        //   UpdateSequence: 1,
        //   IsActive: "Y",
        //   Status: null,
        //   ClientId: clientId,
        //   ProjectId: projectCode,
        // });
        // Close the popover after updating
        setpriorityVisible(false);
      } catch (error) {
        console.error("Error updating issue type:", error);
      }
    }
  };

  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
    setSubmenuAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleSprintMenuOpen = (event) => {
    event.stopPropagation();
    setSubmenuAnchorEl(event.currentTarget);
  };

  const handleSprintMenuClose = () => {
    setSubmenuAnchorEl(null);
    setAnchorEl(null);
  };

  const handleCloneClick = (event, rowData) => {
    event.stopPropagation();
    setclon(true);
    setcdata(selectedRow);
    setIssueTitleedit(selectedRow.IssueTitle);
    handleMenuClose();
    setAnchorEl(null);
  };

  const PriorityOptions = [
    {
      label: "Highest",
      icon: (
        <KeyboardDoubleArrowUpIcon
          className="filter-icons-1"
          style={{
            fontSize: "18px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "High",
      icon: (
        <KeyboardArrowUpIcon
          className="filter-icons-1"
          style={{
            fontSize: "18px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "Medium",
      icon: (
        <DragHandleIcon
          className="filter-icons"
          style={{
            fontSize: "18px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "Low",
      icon: (
        <KeyboardArrowDownIcon
          className="filter-icons-2"
          style={{
            fontSize: "18px",
            marginRight: "5px",
          }}
        />
      ),
    },
    {
      label: "Lowest",
      icon: (
        <KeyboardDoubleArrowDownIcon
          className="filter-icons-2"
          style={{
            fontSize: "18px",
            marginRight: "5px",
          }}
        />
      ),
    },
  ];
  // function selectcustom(rowData) {
  //   return (
  //     <>
  //       <div onClick={() => handleSecondFriend(rowData.IssueIdS)}>
  //         <div
  //           style={{
  //             // backgroundColor: "#eef2f7",
  //             padding: "10px 05px 10px 15px",
  //             width: "45px",
  //           }}
  //         >
  //           <MoreVertIcon
  //             style={{ color: "#198ae3", fontSize: "20px", fontWeight: "bold" }}
  //           />
  //         </div>
  //         {selectedId == rowData.IssueIdS && (
  //           <div
  //             style={{
  //               backgroundColor: "#ffffff",
  //               position: "relative",
  //               width: "200px ",
  //               borderRadius: "3px",
  //             }}
  //           >
  //             <ul style={{ backgroundColor: "#ebedf2" }}>
  //               <div
  //                 style={{ padding: "7px 10px 3px 5%" }}
  //                 onClick={ handleSprintMenuOpen}
  //               >
  //                 <EditIcon style={{ fontSize: "medium" }} />
  //                 {"   "} Move to Sprint
  //               </div>
  //               <div
  //                 style={{ padding: "7px 10px 3px 5%" }}
  //                 // onClick={() => handleReport(rowData, "Report")}
  //               >
  //                 <AssessmentIcon style={{ fontSize: "medium" }} />
  //                 {"    "}clone
  //               </div>
  //               <div
  //                 style={{ padding: "7px 10px 3px 5%" }}
  //                 // onClick={() => handleReport(rowData, "Report")}
  //               >
  //                 <AssessmentIcon style={{ fontSize: "medium" }} />
  //                 {"    "}Delete
  //               </div>
  //             </ul>

  //           </div>
  //         )}
  //       </div>
  //     </>
  //   );
  // }
  //Issue type change//
  const { data: noteData } = useSelector((state) => state.note); 
  // Fetch data once when the component mounts
  useEffect(() => {
    if (noteData?.length == 0 ) {
      const clientId = JSON.parse(localStorage.getItem("clientid"));
      const userdata = { clientId, projectCode, env: "DEV,UAT" };
      dispatch(fetchUserById(userdata));
    }
  }, [dispatch, projectCode,noteData]);
  


  const Columns1 = [
    {
      title: "Ticket reference ",
      field: "IssueType",
      // cellStyle: { width: "14%" },
    },
    {
      title: "Title",
      field: "IssueTitle",
      cellStyle: { width: "25%" },
      render: (rowData) => <IssueTitleCell data={rowData} />,
    },
    {
      title: "Assignee",
      field: "Assignedid",
      render: (e) => (
        <Select
          components={{
            // DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          options={userdropdownoptions}
          value={userdropdownoptions?.filter(
            (option) => option.value === e.Assignedid
          )}
          isDisabled={e.Stage !== "Refined"}
          getOptionLabel={(v) => (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="assignee-avatar1">
                <Avatar
                  // sx={{ width: '20px !important', height: '20px !important' }}
                  alt=""
                  src={
                    allImage?.length > 0
                      ? allImage?.filter((x) => x.teammemberid == v.value)?.[0]
                          ?.image
                      : Unassigned
                  }
                />
              </div>
              <span style={{ marginLeft: 10, fontWeight: "normal" }}>
                {v.label}
              </span>
            </div>
          )}
          placeholder="Select assignee"
          onChange={(selectedOption) =>
            handleSelectChange(selectedOption, e.IssueId, e.Assignedid, e)
          }
          styles={customStyles}
          menuPortalTarget={document.body} // Render dropdown in portal outside of popover
          menuPosition="fixed" // Fix dropdown to viewport, not scroll position
          menuPlacement="auto" // Automatically place the dropdown above/below as needed
        />
      ),
    },
    {
      title: "Original Estimate",
      field: "OriginalEstimate",
      // headerStyle: { border: '2px solid red' },
      // cellStyle: { textAlign: 'center', width: '5%' },
      render: (e) => (
        <span className="ml-4">
          {e.OriginalEstimate ? e.OriginalEstimate + " Days" : 0 + " Days"}
        </span>
      ),
    },
    {
      title: "% Work",
      field: "percentageprogressed",
      render: (e) => (
  
        <Box>
          {/* <Slider
                    className={getColor(e?.percentageprogressed === "" ? 0 : Number(e?.percentageprogressed))}
                    size="small"
                    value={e?.percentageprogressed === "" ? 0 : Number(e?.percentageprogressed)}
                    aria-label="Small"
                    valueLabelDisplay="auto"
                    disabledSlider={true}
                /> */}
          <ProgressBar
            style={{ height: "12px" }}
            variant={
              e.percentageprogressed >= 75
                ? "success"
                : e.percentageprogressed === 0
                ? "danger"
                : "warning"
            }
            // animated
            now={e.percentageprogressed}
            label={
              <span style={{ fontSize: "10px" }}>{e.percentageprogressed}</span>
            }
          />
              <Tooltip title="Stage">
           <span  style={{
            fontSize: "10px",
            fontWeight: "bold",
    marginLeft:"30px",
            marginTop: "4px",
            display: "block",
          }}>
        {e.Stage === "Refined"
          ? "RFD"
          : e.Stage === "Backlog"
          ? "BLG"
          : e.Stage === "In Development"
          ? "DEV"
          : e.Stage === "User Acceptace Testing"
          ? "UAT"
          : e.Stage === "Done"
          ? "DONE"
          : null}
      </span>
      </Tooltip>
        </Box>
      ),
    },
    {
      title: "Due days",
      field: "effortremaining",
      render: (e) => (
        <>
          <label
            style={{
              marginRight: "8px",
              // marginTop: "6px",
              color:
                e.RiskofDelivery == null
                  ? "#000"
                  : e.RiskofDelivery === "A"
                  ? "#FFEA7A"
                  : e.RiskofDelivery === "G"
                  ? "#5EB983"
                  : e.RiskofDelivery === "R"
                  ? "#DF2E2E"
                  : "white",
              fontSize: "18px",
            }}
          >
            {e.RiskofDelivery != null && <span class="mdi mdi-flag"></span>}
          </label>
          <label>
            {e?.effortremaining == null
              ? "--"
              : e?.effortremaining < 0
              ? -e.effortremaining + " Days Over Due"
              : e?.effortremaining + " Days"}
          </label>
        </>
      ),
    },

    { title: "Reason", field: "Reason", hidden: !displayDropdown },
    { title: "Notes", field: "Notes", hidden: !displayDropdown },
    // {
    //   title: "",
    //   field: "delete",
    //   hidden: labelvi?.includes("Planned") != true,
    //   render: (e) =>
    //     (labelvi?.includes("Planned") == true && projectRole == "SM") ||
    //     projectRole == "ITMGR2" ||
    //     projectRole == "QA" ||
    //     getProdRole == "KA" ? (
    //       <Button className="buttoon" onClick={() => handleissueid(e)}>
    //         <DeleteOutlineIcon color="error" />
    //       </Button>
    //     ) : null,
    // },
    {
      title: "Reason",
      field: "Reasons",
      hidden: !displayReason,
      render: (e) => removed.filter((x) => x.IssueId === e.IssueId)[0]?.Reason,
    },

    // Check if the labels and project roles match the condition

    {
      title: "Action",
      field: "Action",
      hidden: !(
        labelvi.includes("Release") || // Ensure Action column is visible when labelvi includes "Release"
        ((labelvi.includes("In-Flight") ||
          labelvi.includes("Planned") ||
          labelvi.includes("To Be Released")) &&
          (projectRole === "SM" ||
            projectRole === "ITMGR2" ||
            projectRole === "QA" ||
            getProdRole === "KA"))
      ),
      render: (rowData) => {
        if (labelvi.includes("Release")) {
          // Render only the Clone option for "Release"
          return (
            <>
              <IconButton
                onClick={(event) => handleMenuOpen(event, rowData)}
                aria-controls={`simple-menu-${rowData.IssueIdS}`}
                aria-haspopup="true"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id={`simple-menu-${rowData.IssueIdS}`}
                anchorEl={anchorEl}
                open={Boolean(
                  anchorEl && selectedRow?.IssueIdS === rowData.IssueIdS
                )}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    padding: "5px",
                    minWidth: "150px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "2px",
                    backgroundColor: "#fff",
                    border: "0.5px solid black",
                  },
                }}
              >
                <MenuItem
                  onClick={(event) => handleCloneClick(event, rowData)}
                  style={{
                    padding: "12px 20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ListItemIcon>
                    <ContentCopyIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Clone" />
                </MenuItem>
              </Menu>
            </>
          );
        }
    
        // Existing condition remains unchanged
        const conditionMet =
          (labelvi.includes("In-Flight") ||
            labelvi.includes("Planned") ||
            labelvi.includes("To Be Released")) &&
          (projectRole === "SM" ||
            projectRole === "ITMGR2" ||
            projectRole === "QA" ||
            getProdRole === "KA");
    
        return conditionMet ? (
          <>
            <IconButton
              onClick={(event) => handleMenuOpen(event, rowData)}
              aria-controls={`simple-menu-${rowData.IssueIdS}`}
              aria-haspopup="true"
            >
              <MoreVertIcon />
            </IconButton>
    
            <Menu
              id={`simple-menu-${rowData.IssueIdS}`}
              anchorEl={anchorEl}
              open={Boolean(
                anchorEl && selectedRow?.IssueIdS === rowData.IssueIdS
              )}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                style: {
                  display: "flex",
                  flexDirection: "column",
                  padding: "5px",
                  minWidth: "150px",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "2px",
                  backgroundColor: "#fff",
                  border: "0.5px solid black",
                },
              }}
            >
              <MenuItem
                onClick={handleSprintMenuOpen}
                style={{
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon>
                  <KeyboardArrowRight fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Move to Sprint" />
              </MenuItem>
    
              <MenuItem
                onClick={(event) => handleCloneClick(event, rowData)}
                style={{
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon>
                  <ContentCopyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Clone" />
              </MenuItem>
              {/* <MenuItem
                onClick={(event) => handleCloneClick(event, rowData)}
                style={{
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon>
                  <CreateNewFolder fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Edit" />
              </MenuItem> */}
    
              {labelvi.includes("Planned") && (
                <MenuItem
                  onClick={() => {
                    if (selectedRow) {
                      handleissueid(selectedRow);
                    } else {
                      console.error("No row selected for deletion");
                    }
                    handleMenuClose();
                  }}
                  style={{
                    padding: "12px 20px",
                    display: "flex",
                    alignItems: "center",
                    color: "#FF3B30",
                  }}
                >
                  <ListItemIcon>
                    <DeleteOutlineIcon
                      fontSize="small"
                      style={{ color: "#FF3B30" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Remove" />
                </MenuItem>
              )}
            </Menu>
            <Menu
            id={`submenu-${rowData.IssueIdS}`}
            anchorEl={submenuAnchorEl}
            open={Boolean(submenuAnchorEl)}
            onClose={handleSprintMenuClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              style: {
                padding: "8px",
                minWidth: "180px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "2px",
                backgroundColor: "#fff",
                border: "0.5px solid black",
              },
            }}
          >
            {releasesOption234.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => {
                  const releasedd = releasedata
                    ?.filter(
                      (item) =>
                        item.IsReleaseFrozen === "N" &&
                        item.Status === null &&
                        item.ReleaseName === option.label
                    )
                    ?.map((e) => e)[0];
                  sprintupdateu(releasedd, selectedRow);
                  handleSprintMenuClose();
                }}
                style={{
                  padding: "6px 12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={agile}
                  alt={option.label}
                  width="18"
                  height="18"
                  style={{ marginRight: "8px" }}
                />
                {option.label}
              </MenuItem>
            ))}
          </Menu>
          
          </>
        ) : null;
      },
    }
    
  ];

  const handleVisibleChange = (visible, index) => {
    if (labelvi.includes("In-Flight") || labelvi.includes("Planned")) {
      if (visible) {
        setPopoverVisible(index); // Open the clicked popover
      } else {
        setPopoverVisible(null); // Close the popover when clicking outside
      }
    }
  };
  // console.log(e);
  // console.log(combinedSortedData);

  const releasesOption234 =
       releasedata?.filter((item) => (moment(item.SprintStartDate) < moment() &&
           moment(item.SprintEndDate) > moment()||  moment() < moment(item.SprintStartDate)))
           ?.length == 0
             ? []
             : 
             releasedata
             .filter((item) =>  ( moment(item.SprintStartDate) < moment() &&
                                     moment(item.SprintEndDate) > moment() ||  moment() < moment(item.SprintStartDate)))
       
                 ?.map((e) => {
                   return {
                     ...e,
                     label: e.ReleaseName,
                     value: e.ReleaseName,
                   };
                 });

  const handleVisibleChange2 = (visible, index) => {
    if (labelvi.includes("In-Flight") || labelvi.includes("Planned")) {
      if (visible) {
        setpriorityVisible(index); // Open the clicked popover
      } else {
        setpriorityVisible(null); // Close the popover when clicking outside
      }
    }
  };
  // const handleContextMenu = (event, rowData) => {
  //   event.preventDefault();

  //   setSelectedRow(rowData);
  //   setIssueTitleedit(rowData.IssueTitle); // Set initial issue title
  //   setAnchorEl(event.currentTarget);

  //   setMenuPosition({
  //     mouseX: event.clientX - 2,
  //     mouseY: event.clientY - 4,
  //   });
  // };

  const handlePopoverClose = () => {
    setPopoverAnchorEl(null); // Close the popover
  };

  const releasepatch = (item, e) => {
    axios
      .patch(`agilesaas_issue_details?IssueId=eq.${e.IssueIdS}`, {
        PlannedRelease: item.ReleaseName,
      })
      .then(async (a) => {
        if (e?.AssignedTo) {
          Mailandnotification(
            e,
            EmpDropDownData?.filter((x) => x.teammemberid == e?.AssignedTo)?.[0]
              ?.email,
            [empid?.[0]?.OfficialEmail],
            true,
            false,
            projectName,
            "Sprint Update",
            e.IssueTitle + " is assigned to " + item.value + " sprint"
          );
          if (slack && slack == "Y") {
            slacknotify(
              channelname,
              e.IssueTitle + " is assigned to " + item.value + " sprint",
              slacktoken
            );
          }
        }
        await axios
          .post("agilesaas_issue_history", {
            IssueId: e.IssueIdS,
            ChangedBy: clientId,
            ChangedByDetails: {
              FN: login?.[0]?.UserFirstname,
              LN: login?.[0]?.UserLastname,
            },
            ChangedDate: moment()
              .utcOffset("+05:30")
              .format("YYYY-MM-DDTHH:mm:ss"),
            UpdatedField: "Releases",
            UpdatedFrom: e.PlannedRelease,
            UpdatedTo: item.value,
            UpdateSequence: 1,
            IsActive: "Y",
            Status: null,
            ClientId: clientId,
            ProjectId: projectCode,
          })
          .then((res) => {
            console.log(res);
          });

        // setRefresh(true);
        dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
        dispatch(HANDLE_ON_CHANGE({ name: "kbrefreshstate", value: true }));
        fetchData();
        toast.success(`Issue moved to ${item.ReleaseName}`);
        // setEnablesprint(false)
      });
  };
  function removeAllOccurrencesFromArray(array, key, value) {
    let index;
    while ((index = array.findIndex((item) => item[key] === value)) !== -1) {
      array.splice(index, 1);
    }
    return array;
  }

  const sprintupdateu = (item, e) => {
    if (e.Version != item?.ReleaseName) {
      axios
        .get(
          `agilesaas_releases?ReleaseId=eq.${item?.ReleaseId}&select=ReleaseIssues`
        )
        .then((res) => {
          const data = res?.data?.[0]?.ReleaseIssues;
          let patchdata = data
            ? [...data, { IssueId: e.IssueIdS, IssueTitle: e?.IssueTitle }]
            : [{ IssueId: e.IssueIdS, IssueTitle: e?.IssueTitle }];
          if (e.Version == null) {
            axios
              .patch(`agilesaas_releases?ReleaseId=eq.${item?.ReleaseId}`, {
                ReleaseIssues: patchdata,
              })
              .then((res1) => {
                releasepatch(item, e);
              });
          } else if (e.Version) {
            axios
              .patch(`agilesaas_releases?ReleaseId=eq.${item?.ReleaseId}`, {
                ReleaseIssues: patchdata,
              })
              .then((res) => {
                axios
                  .get(
                    `agilesaas_releases?ReleaseName=eq.${e.Version}&select=ReleaseIssues,ReleaseId`
                  )
                  .then((response) => {
                    const data = response?.data?.[0];
                    axios
                      .patch(
                        `agilesaas_releases?ReleaseId=eq.${data?.ReleaseId}`,
                        {
                          ReleaseIssues: removeAllOccurrencesFromArray(
                            data?.ReleaseIssues,
                            "IssueId",
                            e?.IssueIdS
                          ),
                        }
                      )
                      .then((r1) => {
                        releasepatch(item, e);
                      });
                  });
              });
          }
        });
    }
  
    
    // console.log(item, "rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr", e, "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
  };
 
  const MemoizedManagerNotes = React.memo(ManagerNotes);
  const handleDetailPanel = (rowData) => (
    <MemoizedManagerNotes issueIdrow={rowData.IssueIdS} data={noteData}  />
  );
  // Renaming `data` to `noteData` to avoid conflicts




  return (
    <div>
      <div>
        <MaterialTable
          title={"Sprint Details"}
          columns={Columns1.map((e) => e)}
          components={{
            Pagination: PatchedPagination,
            // Row: (props) => {
            //   if (labelvi.includes("In-Flight") || labelvi.includes("Planned") || labelvi.includes("To Be Released")) {
            //     return (
            //       <MTableBodyRow
            //         {...props}
            //         onContextMenu={(event) => {
            //           event.preventDefault();
            //           handleContextMenu(event, props.data);
            //         }}
            //       />
            //     );
            //   } else {

            //     return <MTableBodyRow {...props} />;
            //   }}
          }}
          // detailPanel={(rowData) => {
          //   const filteredData = FilteredData?.filter(([issueId]) => issueId === rowData.IssueIdS)
          //     ?.map(([issueId, issueData]) => {
          //       const filteredUpdates = assignedmem
          //         ? issueData.filter((item) => item?.UpdatedBy === assignedmem)
          //         : issueData;
       
          //       const images = filteredUpdates?.[0]?.Notes?.match(/<img .*?>/g);
          //       const extractedImageSrcArray = images?.map((image) => {
          //         const srcMatch = image?.match(/src=['"](.*?)['"]/);
          //         return { src: srcMatch ? srcMatch[1] : null };
          //       });
        
          //       const result = getComparisonResult(filteredUpdates);
          //       const percentageIncrease = result.percentageIncrease;
          //       const comparisonResult = result.comparisonResult;
        
          //       return (
          //         <Card key={issueId} className="m-2 p-2">
          //           <div className="d-flex align-items-center" style={{ gap: "5px" }}>
          //             <Avatar
          //               sx={{ width: 25, height: 25 }}
          //               alt=""
          //               src={allImage?.find((x) => x?.teammemberid === filteredUpdates[0]?.UpdatedBy)?.image || Unassigned}
          //             />
          //             <p className="text-primary">
          //               {filteredUpdates[0]?.UpdatedByDetails?.FN + " " + filteredUpdates[0]?.UpdatedByDetails?.LN}
          //             </p>
          //           </div>
          //           <div className="d-flex justify-content-between">
          //             <div>
          //               <b>{`${filteredUpdates[0]?.title} - (${issueId ?? "N/A"})`}</b>
          //               <p>{moment(filteredUpdates[0]?.UpdatedDate).format("DD MMMM YYYY  h:mm:ss a")}</p>
          //             </div>
          //             <p>{filteredUpdates[0]?.EffortRemaining ? `${filteredUpdates[0]?.EffortRemaining} days left` : null}</p>
          //           </div>
          //           <div style={{ fontSize: "14px" }}>
          //             {filteredUpdates[0]?.Notes ? FilterCheerio(filteredUpdates[0]?.Notes) : "recently moved to dev"}
          //           </div>
          //           <div className="d-flex justify-content-between align-items-center mt-2">
          //             <CircularProgressWithLabel value={filteredUpdates[0]?.PercentageProgressed} />
          //             <div>
          //               {comparisonResult}
          //               <p className="text-dark">{filteredUpdates[0]?.StageCode}</p>
          //             </div>
          //           </div>
          //         </Card>
          //       );
          //     });
          //     console.log(filteredData,"filter",selectorData);
        
          //   return <div>{filteredData.length > 0 ? filteredData : <span>No updates available.</span>}</div>;
          // }}
          detailPanel={handleDetailPanel}
          
          
          data={combinedSortedData.map((e, i) => {
            const isSubtask = e.IssueType === "SubTask";
            let icon;

            return {
              ...e,

              IssueType: (
                <div>
                  <div style={{ paddingLeft: isSubtask ? "20px" : "0" }}>
                    {/* PriorityChange */}
                    <Space wrap>
                      {/* {console.log(priorityVisible)} */}
                      <Popover
                        key={i} // indicates the index
                        open={
                          priorityVisible === i &&
                          (labelvi.includes("In-Flight") ||
                            labelvi.includes("Planned"))
                        } // Control which popover is visible
                        zIndex={2000}
                        content={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            {PriorityOptions?.map((item) => (
                              <div
                                // key={item.label}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  updatePriority(e, item.label); //function
                                  setpriorityVisible(null); // Close the popover after selecting an item
                                }}
                              >
                                {item.icon}
                                {item.label}
                                {/* {console.log(priorityVisible)} */}
                              </div>
                            ))}
                          </div>
                        }
                        trigger="click"
                        onOpenChange={(visible) =>
                          handleVisibleChange2(visible, i)
                        }
                        // Handle visibility changes
                        overlayStyle={{ width: "100px" }} // Adjust the overall popover width
                      >
                        <span
                          className="cardIcon2"
                          onClick={(event) => {
                            setpriorityVisible(i); // Toggle popover visibility
                            event.stopPropagation();
                          }}
                        >
                          {e.Priority === "Highest" ? (
                            <span>
                              <KeyboardDoubleArrowUpIcon
                                className="filter-icons-1"
                                fontSize="small"
                              />
                            </span>
                          ) : e.Priority === "High" ? (
                            <span>
                              <KeyboardArrowUpIcon
                                className="filter-icons-1"
                                fontSize="small"
                              />
                            </span>
                          ) : e.Priority === "Medium" ? (
                            <span>
                              <DragHandleIcon
                                className="filter-icons"
                                fontSize="small"
                              />
                            </span>
                          ) : e.Priority === "Low" ? (
                            <span>
                              <KeyboardArrowDownIcon
                                className="filter-icons-2"
                                fontSize="small"
                              />
                            </span>
                          ) : e.Priority === "Lowest" ? (
                            <span>
                              <KeyboardDoubleArrowDownIcon
                                className="filter-icons-2"
                                fontSize="small"
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </Popover>
                    </Space>{" "}
                    <Space wrap>
                      {/* {console.log(popoverVisible, i)} */}
                      <Popover
                        key={i} // indicates the index
                        open={
                          popoverVisible === i &&
                          (labelvi.includes("In-Flight") ||
                            labelvi.includes("Planned"))
                        } // Control which popover is visible
                        zIndex={2000}
                        content={
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            {IssutypeOptions?.map((item) => (
                              <div
                                key={item.label}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  updateIssueType(e, item.label);
                                  setPopoverVisible(null); // Close the popover after selecting an item
                                }}
                              >
                                {item.icon}
                                {item.label}
                                {/* {console.log(IssutypeOptions)} */}
                              </div>
                            ))}
                          </div>
                        }
                        trigger="click"
                        onOpenChange={(visible) =>
                          handleVisibleChange(visible, i)
                        } // Handle visibility changes
                        overlayStyle={{ width: "100px" }} // Adjust the overall popover width
                      >
                        <span
                          className="cardIcon2"
                          onClick={(event) => {
                            // console.log(e.ReleaseName);
                            setPopoverVisible(i); // Toggle popover visibility
                            event.stopPropagation();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {e.IssueType === "Story" && (
                            <Bookmark
                              className="story fonticons"
                              style={{ fontSize: "13px" }}
                            />
                          )}
                          {e.IssueType === "Task" && (
                            <CheckBoxRoundedIcon
                              className="task fonticons"
                              style={{ fontSize: "13px" }}
                            />
                          )}
                          {e.IssueType === "Bug" && (
                            <StopCircleIcon
                              className="bug fonticons"
                              style={{ fontSize: "13px" }}
                            />
                          )}
                        </span>
                      </Popover>
                    </Space>
                    <label className="mb-0"> {icon} </label>
                    <label
                      style={{
                        color: "#198ae3",
                        marginLeft: "8px",
                        whiteSpace: "pre-wrap",
                      }}
                      sx={{ width: 25, height: 25 }}
                    >
                      {e.IssueId}
                    </label>
                  </div>
                </div>
              ),
              Reason:
                (e.Stage != "Done" &&
                  e.Stage != "User Acceptace Testing" &&
                  projectRole == "SM") ||
                projectRole == "ITMGR2" ||
                projectRole == "QA" ||
                getProdRole == "KA" ? (
                  <div>
                    <p style={{ width: "130px", paddingTop: "15px" }}>
                      {/* <TextField style={{ borderWidth: 0, display: 'hidden', height: 0, width: 100, borderColor: 'red' }} /> */}
                      <Select
                        id={i}
                        // className="reasondropdown"
                        // style={{ height: 40 }}

                        options={Reasonoption}
                        onChange={(x) => handlereason(x, i, e)}
                        required
                        placeholder="Select "
                      />
                    </p>
                  </div>
                ) : null,
              Notes:
                (e.Stage != "Done" &&
                  e.Stage != "User Acceptace Testing" &&
                  projectRole == "SM") ||
                projectRole == "ITMGR2" ||
                projectRole == "QA" ||
                getProdRole == "KA" ? (
                  <TextField
                    style={{ width: 110 }}
                    id={i}
                    variant="outlined"
                    className="notes "
                    size="small"
                    placeholder="Notes"
                    onChange={(x) => handlenotes(x, i, e)}
                    type="text"
                    autoComplete="off"
                    required
                  />
                ) : (
                  "-"
                ),
            };
          })}
          options={{
            actionsColumnIndex: -1,
            exportAllData: true,
            exportButton: true,
            columnResizable: true,
            filtering: false,
            sorting: true,
            paging: true,
            pageSize: 20,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [20, 30, 40, 50],

            headerStyle: {
              whiteSpace: "nowrap",
              fontWeight: "700",
              fontSize: "medium",
              // backgroundColor: "#eef2f7",
              color: "black",
              // padding: "9px ",
              textAlign: "left",
            },
            cellStyle: {
              textAlign: "left",
              fontSize: "medium",
              padding: "21px",
              color: "#6c757d",
              whiteSpace: "nowrap",
            },
            
            rowStyle: (rowdata) => {
              if (rowdata.tableData.id % 2 != 0) {
                // return { backgroundColor: "#cddef085" };
              }
            },
            
          }}
          localization={{
            body: {
              emptyDataSourceMessage: "🚀 No tickets are scheduled for this sprint. Let's plan and prioritize effectively! 📋", // Custom error message
            },
          }}
          // onRowClick={(evt, selectedRow) =>
          //     setSelectedRow(selectedRow.tableData.id)
          // }
        />

        <Dialog
          open={clon}
          onClose={() => setclon(false)}
          className="mainbox"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Row
              className=""
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Col lg={10} md={10}>
                <label
                  className="text-secondary fontdesign"
                  style={{ fontWeight: "bold" }}
                >
                  Clone the ticket with Id - ({cdata.IssueIdS})
                </label>
              </Col>
              <div className="d-flex justify-content-end">
                <IconButton onClick={() => closepppp()}>
                  <CloseIcon />
                </IconButton>
              </div>
            </Row>
          </DialogTitle>
          <DialogContent>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                In which stage, the card should be cloned to
              </label>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                <button
                  type="button"
                  className={`btn btn-custom ${
                    stage === "Refined" ? "selected" : "not-selected"
                  }`}
                  value="Refined"
                  onClick={() => handleStageChange("Refined")}
                >
                  Refined
                </button>
                <button
                  type="button"
                  className={`btn btn-custom ${
                    stage === "Backlog" ? "selected" : "not-selected"
                  }`}
                  value="Backlog"
                  onClick={() => handleStageChange("Backlog")}
                >
                  Backlog
                </button>
              </div>
            </div>
            <Box marginBottom="20px">
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Title
              </label>
              <Input
                onChange={handleInputChange}
                value={issueTitleedit}
                className="SprintFormFields"
                placeholder="Enter Title"
                fullWidth
              />
            </Box>
            <Box marginBottom="20px">
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Select Sprint
                {releasesOption234.length === 0 && (
                  <div className="text-muted" style={{ marginTop: "10px" }}>
                    No active sprints available
                  </div>
                )}
              </label>
              <Select
                styles={customStylesclone}
                options={releasesOption234}
                value={
                  releasesOption234 &&
                  releasesOption234.find((option) => option.value === sprintc)
                }
                onChange={(e) => setSprintc(e?.value)}
                placeholder={<span>Select Sprint</span>}
                components={{
                  SingleValue: CustomSingleValue,
                  Option: CustomOption,
                }}
                isDisabled={releasesOption234.length === 0}
              />
            </Box>

            <Box marginBottom="70px" marginTop="20px">
              <label
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  display: "block",
                  marginBottom: "10px",
                }}
              >
                Assigned To
              </label>
              <Select
                name="AssignedTo"
                placeholder="Select Employee"
                options={EmployeeDropdownc}
                styles={customStylesclone}
                onChange={handleAssignedTo}
                value={EmployeeDropdownc.filter(
                  (option) => option.label === assignedEmployeeNc
                )}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => closepppp()}
                style={{
                  fontSize: 14,
                  padding: 9,
                  width: 100,
                  height: 40,
                  borderRadius: 8,
                  marginRight: 14,
                  border: "2px solid #5250E5",
                  backgroundColor: "#fff",
                  color: "#5250E5",
                  textAlign: "center",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleclonesubmit}
                disabled={isSubmittingc}
                style={{
                  fontSize: 14,
                  padding: 9,
                  width: 100,
                  height: 40,
                  borderRadius: 8,
                  backgroundColor: "#5250E5",
                  color: "#fff",
                  border: "0px solid #5A88F1",
                  textAlign: "center",
                  textTransform: "none",
                }}
              >
                Submit
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
      {/* <CloneDialog
        open={clon}
        // onClose={}
        // handleCloneSubmit={handleCloneSubmit}
        sprintOptions={releasesOption23}
        employeeOptions={EmployeeDropdown}
        initialIssueData={ cdata|| {}}
      /> */}
    </div>
  );
}

